import { render, staticRenderFns } from "./newShareManuscript.vue?vue&type=template&id=699452e6&scoped=true&"
import script from "./newShareManuscript.vue?vue&type=script&lang=js&"
export * from "./newShareManuscript.vue?vue&type=script&lang=js&"
import style0 from "./newShareManuscript.vue?vue&type=style&index=0&id=699452e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699452e6",
  null
  
)

export default component.exports